import React from 'react'
import { Card, CardContent, Dialog, DialogContent, Stack, Typography } from '@mui/material'
import normalIMG from '../../../assets/pictures/admin/PERIOD_normal.png'
import truncIMG from '../../../assets/pictures/admin/PERIOD_trunc.png'
import noLawIMG from '../../../assets/pictures/admin/PERIOD_noLaw.png'
import percentIMG from '../../../assets/pictures/admin/PERIOD_percent.png'
import PropTypes from 'prop-types'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import { CardTitle } from 'components/card/NewCard'
import { mainBlue } from 'utils/constants/ColorTheme'

const FrequencyStatCalculationMethodPopup = ({
    selectedMode,
    changeMode,
    onClose,
    isOpen,
}) => {
    if (!isOpen) {
        return null
    }
    const getAction = (mode) => [{
        icon: mode === selectedMode ? 'check_box' : 'check_box_outline_blank',
        onClick: mode === selectedMode ? () => {} : () => changeMode(mode),
        color: 'white',
    }]
    return (
        <Dialog
            onClose={onClose}
            fullWidth
            maxWidth='lg'
            open={isOpen}
        >
            <DefaultDialogTitle title={'Modifier la méthode de calcul des périodes de retour'} onClose={onClose} />
            <DialogContent>
                <Stack spacing={2}>
                    <Card>
                        <CardTitle title={'Loi normale'} color={mainBlue} actions={ getAction('normal') }/>
                        <CardContent>
                            <Stack spacing={1}>
                                <Typography>{'La loi normale est utilisée dans le calcul des périodes de retour. C\'est la méthode de calcul la plus utilisée par le BRGM et les DREAL a l\'heure actuelle.'}</Typography>
                                <Typography>{'Avec cette méthode, du fait de certains biais statistiques liés à la loi normale, il est possible que certaines périodes de retour dépassent l\'enveloppe min/max.'}</Typography>
                                <Typography>{'Ces biais statistiques sont causés par le fait que la distribution des niveaux ne suit pas tout à fait une loi normale. C\'est le cas dans l\'exemple ci dessous avec la cinquantennale sèche qui dépasse l\'enveloppe min.'}</Typography>
                                <img src={normalIMG} />
                            </Stack>
                        </CardContent>
                    </Card>
                    <Card>
                        <CardTitle title={'Loi normale tronquée'} color={mainBlue} actions={ getAction('trunc') }/>
                        <CardContent>
                            <Stack spacing={1}>
                                <Typography>{'La loi normale est utilisée dans le calul des périodes de retour. Par contre, si un résultat dépasse l\'enveloppe min/max, le résultat sera l\'enveloppe min/max dépassée.'}</Typography>
                                <img src={truncIMG} />
                            </Stack>
                        </CardContent>
                    </Card>
                    <Card>
                        <CardTitle title={'Pourcentage par rapport à la moyenne'} color={mainBlue} actions={ getAction('percent') }/>
                        <CardContent>
                            <Stack spacing={1}>
                                <Typography>{'Pour ce calcul, on se sert de la moyenne et du min ou max historique. En fonction de la période de retour, un coefficient est appliqué.'}</Typography>
                                <Typography>{'Par exemple pour la triennale humide, on a un coefficient de 0.333. On applique la formule suivante (avec avg la moyenne, max l\'enveloppe max) : avg + (max - avg) x (1 - 0.333)².'}</Typography>
                                <Typography>{'Pour une triennale sèche, on aura : avg - (avg - min) x (1 - 0.333)².'}</Typography>
                                <Typography>{'Cette méthode permet d\'avoir des classes bien réparties pour chaque période de retour, avec la promesse de ne pas dépasser l\'enveloppe min/max.'}</Typography>
                                <Typography>{'Cependant, elle ne calcule pas de réelles périodes de retour mais plutôt des calculs statistiques qui s\'en rapprochent.'}</Typography>
                                <img src={percentIMG} />
                            </Stack>
                        </CardContent>
                    </Card>
                    <Card>
                        <CardTitle title={'Sans loi statistique'} color={mainBlue} actions={ getAction('noLow') }/>
                        <CardContent>
                            <Stack spacing={1}>
                                <Typography>{'Aucune loi statistique est utilisée dans le calul des périodes de retour. Les résultats sont des vraies valeurs qui sont dans l\'historique de la courbe.'}</Typography>
                                <Typography>{'Avec cette méthode, c\'est impossible que certaines périodes de retour dépassent l\'enveloppe min/max.'}</Typography>
                                <Typography>{'Par contre, il est possible qu\'une même valeur se retrouve dans plusieures périodes de retour à la fois, si par exemple elle est présente un nombre de fois assez important dans l\'historique. (On le voit dans l\'exemple ci dessous au niveau de la flèche rouge)'}</Typography>
                                <img src={noLawIMG} />
                            </Stack>
                        </CardContent>
                    </Card>
                </Stack>
            </DialogContent>
        </Dialog>
    )
}

FrequencyStatCalculationMethodPopup.propTypes = {
    selectedMode: PropTypes.string,
    changeMode: PropTypes.func,
    onClose: PropTypes.func,
    isOpen: PropTypes.bool,
}

export default FrequencyStatCalculationMethodPopup
